import React from 'react';

export default function EquipmentPage() {
    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <iframe
                src='https://qa.dfinite.ai/equip'
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block'
                }}
                title='설비명 매핑 관리'
            />
        </div>
    );
}
